import { Injectable } from "@angular/core"
import { IUtente } from "app/shared/models/utente.interface"
import { BASEMysqlService } from "./_base"

@Injectable({
  providedIn: 'root'
})
export class MysqlServiceUsers extends BASEMysqlService {


  static TYPE_ADMIN = 'ADMIN'
  static TYPE_CLIENT = 'CLIENTE'
  static TYPE_DRIVER = 'DRIVER'
  static TYPE_CENTER = 'CENTRO'

  prefix = 'users_'

  login(email: string, password: string): Promise<any> {

    let data = { email: email, password: password }
    console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'login', data).toPromise();

  }

  list(livello?: string): Promise<any> {
    let data = {
      auth: this.getAuth(),
      livello: livello
    }

    return this.http.post(this.URL_BASE + this.prefix + 'list', data).toPromise();
  }
  /*
    list_by_type(type: string, d = undefined): Promise<any> {
      let data = {
        auth: this.getAuth(),
        type: type,
        dta: d
      }
  
      return this.http.post(this.URL_BASE + this.prefix + 'list_by_type', data).toPromise();
    }
  */

  upsert(item: IUtente): Promise<any> {
    let data = {
      auth: this.getAuth(),
      item: item
    }

    return this.http.post(this.URL_BASE + this.prefix + 'upsert', data).toPromise();
  }

  get(id: string = ''): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    return this.http.post<any>(this.URL_BASE + this.prefix + 'get', data).toPromise();
  }
  get_profile(email): Promise<any> {
    let data = {
      auth: this.getAuth(),
      email: email
    }

    return this.http.post(this.URL_BASE + this.prefix + 'get_profile', data).toPromise();

  }

  getAvatar(id, email): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id,
      email: email
    }

    return this.http.post<any>(this.URL_BASE + this.prefix + 'get_avatar', data).toPromise();
  }

  upsertAvatar(image, email?, id?) {
    let data = {
      auth: this.getAuth(),
      image: image,
      email: email ? email : this.getAuth().email,
      id: id
    }

    return this.http.post<any>(this.URL_BASE + this.prefix + 'upsert_avatar', data).toPromise();
  }

  /*
   upsert_utente_geo(email, geo): Promise<IAnagrafica[]> {
     let data = {
       auth:this.getAuth(),
       email: email,
       geo: geo
     }
 
     return this.http.post<IAnagrafica[]>(this.URL_BASE + this.prefix + 'upsert_utente_geo', data).toPromise();
   }
 
  
   upsert_utente_zone(email, zones): Promise<any> {
     let data = {
       auth:this.getAuth(),
       email: email,
       zones: zones
     }
 
     return this.http.post<IAnagrafica[]>(this.URL_BASE + this.prefix + 'upsert_utente_zone', data).toPromise();
   }
 */

  delete(id: number): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    return this.http.post(this.URL_BASE + this.prefix + 'delete', data).toPromise();
  }

  get_current_profile(): Promise<any> {
    let data = {
      auth: this.getAuth(),
    }

    return this.http.post(this.URL_BASE + this.prefix + 'get_current_profile', data).toPromise();

  }

  change_pwd_request(): Promise<any> {
    let data = {
      auth: super.getAuth(),
    }


    return this.http.post(this.URL_BASE + this.prefix + 'change_pwd_request', data).toPromise();

  }

  change_pwd_confirm(hash: string, password: string): Promise<any> {
    let data = {
      token: hash,
      password: password
    }

    return this.http.post(this.URL_BASE + this.prefix + 'change_pwd_confirm', data).toPromise();

  }

  get_nearest_by_type(type: string, centro_riparazione: boolean, centro_gomme: boolean, centro_cr: boolean, location: any) {
    let data = {
      auth: super.getAuth(),
      type: type,
      centro_riparazione: centro_riparazione,
      centro_gomme: centro_gomme,
      centro_cr: centro_cr,
      location: location
    }

    return this.http.post(this.URL_BASE + this.prefix + 'get_nearest_by_type', data).toPromise();

  }

}